import { AuthUser } from '../../services/api';

export type { AuthUser as User };

export interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  needsNiceLink: boolean;
  error: string | null;
}

export interface AuthContextValue extends AuthState {
  signInWithNice: () => Promise<void>;
  logout: () => Promise<void>;
  refreshToken: () => Promise<void>;
}

export const initialAuthState: AuthState = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isLoading: true,
  needsNiceLink: false,
  error: null,
};
